import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/pc/index'
// import about from '@/components/pc/about'
// import indexH5 from '@/components/h5/indexH5'
// import aboutH5 from '@/components/h5/aboutH5'
// import merchantLoad from '@/components/h5/merchantLoad'
// import agentLoad from '@/components/h5/agentLoad'



Vue.use(Router)

export default new Router({
  	mode: 'history',
  	routes: [
		{
			path: '/',
			name: 'index',
			redirect: '/index'
		},
		{
			path: '/',
			component: resolve => require(['@/components/pc/center'], resolve),
			meta: { title: '主頁' },
			children:[
				{
					path : '/index',
					component: resolve => require(['@/components/pc/index'], resolve),
					meta: { title: '首頁' }
                },
                {
					path : '/indexH5',
					component: resolve => require(['@/components/h5/indexH5'], resolve),
					meta: { title: '首頁' }
                },
                {
					path : '/product',
					component: resolve => require(['@/components/pc/product'], resolve),
					meta: { title: '產品介紹' }
                },
                {
					path : '/productDetail',
					component: resolve => require(['@/components/pc/productDetail'], resolve),
					meta: { title: '產品介紹' }
				},
				{
					path : '/partner',
					component: resolve => require(['@/components/pc/partner'], resolve),
					meta: { title: '合作夥伴' }
				},
				{
					path : '/about',
					component: resolve => require(['@/components/pc/about'], resolve),
					meta: { title: '關於我們' }
				},
				{
					path : '/global',
					component: resolve => require(['@/components/pc/global'], resolve),
					meta: { title: '全球合夥人' }
                }
			]
        },
        {
            path : '/merchantLoad',
            component: resolve => require(['@/components/h5/merchantLoad'], resolve),
            meta: { title: '商戶APP下載' }
        },
        {
            path : '/agentLoad',
            component: resolve => require(['@/components/h5/agentLoad'], resolve),
            meta: { title: '代理APP下載' }
        }
    // {
    //   path: '/about',
    //   name: 'about',
    //   component: about
    // },
    // {
    //   path: '/indexH5',
    //   name: 'indexH5',
    //   component: indexH5
    // },
    // {
    //   path: '/aboutH5',
    //   name: 'aboutH5',
    //   component: aboutH5
    // },
    // {
    //   path: '/merchantLoad',
    //   name: 'merchantLoad',
    //   component: merchantLoad
    // },
    // {
    //   path: '/agentLoad',
    //   name: 'agentLoad',
    //   component: agentLoad
    // }
  ],
  scrollBehavior(to,from,savedPosition){
    // return {x:100,y:100}              //浏览器以页面的x:100,y:100的位置开始显示
    // return{ selector : '.a' }         //浏览器以页面中 class 为 a 的 DOM 位置开始显示
		if(savedPosition){                   //如果是通过浏览器的 前进/后退 按钮触发就为 true
			return savedPosition               //浏览器以上回最后一次浏览的页面位置开始显示
		}else{
			return {x:0,y:0}
		}
  	}
})



// WEBPACK FOOTER //
// ./src/router/index.js